import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./lib/auth";
import { FiltrosProvider } from "./lib/filtros";
import App from "./App";
import ErrorBoundary, { puedeRecargarPorFragmento } from "./components/ErrorBoundary";
import { TITULO } from "./lib/rutas";
import { basenameRouter } from "./lib/rutas";
import "./styles/app.css";
import "./styles/extra.css";

// El tema elegido con el botón sol/luna se aplica ANTES del primer render —
// sin esto, quien fijó "oscuro" vería un parpadeo claro al abrir. Sin elección
// guardada, manda el sistema. (Mismo patrón que PILOT.)
document.title = TITULO;

const temaGuardado = localStorage.getItem("kex_tema");
if (temaGuardado === "dark" || temaGuardado === "light") {
  document.documentElement.setAttribute("data-theme", temaGuardado);
}

// UN DEPLOY NO DEBE TUMBAR LAS PESTAÑAS ABIERTAS. Los archivos de cada vista
// llevan un hash: al publicar, los del deploy anterior desaparecen. Una pestaña
// que lleva horas abierta pide el archivo viejo y el import truena. Vite avisa
// con `vite:preloadError` ANTES de que React reviente, así que aquí se recarga
// y la persona ni se entera; el ErrorBoundary queda solo como último recurso.
window.addEventListener("vite:preloadError", (e) => {
  if (!puedeRecargarPorFragmento()) return; // ya se intentó hace nada: que salga el error real
  e.preventDefault();
  window.location.reload();
});

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      // volver a la pestaña revalida lo que ya envejeció (más de staleTime):
      // los datos de Operación son una cola viva, no un reporte estático
      refetchOnWindowFocus: true,
      staleTime: 60_000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <ErrorBoundary>
      <BrowserRouter basename={basenameRouter}>
        <AuthProvider>
          <FiltrosProvider>
            <App />
          </FiltrosProvider>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
